import { useNavigate } from "react-router-dom";

import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useRef, useState } from "react";

import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getUserData } from "../../../utils/localStorage";
import { brandAllCustomerData, brandCustomerUpload, getBrandCustomer } from "../../../services/BrandCustomer/BrandCustomer";
import AdminMenu from "../../AdminMenu";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import SuccessModal from "../../SuccessModal";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { errorMessage, successMessage } from "../../../utils/alertMessage";

// import backgroundImage from "../../../../public/images/customer_mail.png"; // Adjust path as needed

const { innerWidth: width, innerHeight: height } = window;

const BrandCustomerList = () => {
  const navigate = useNavigate();

  const { brandProfileData } = getUserData();

  let brandId = brandProfileData.id;

  let notifyEmail = brandProfileData.notifyEmail;

  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [page, setPage] = useState(0);
  const [visible, setVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
    const [modalStatus, setModalStatus] = useState(false);
    const [modalText, setModalText] = useState("");

  const [brandCustomerData, setBrandCustomerData] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const [isEndReached, setIsEndReached] = useState(false);
  const ds = useRef(null);

  const [displayCustomerUpload, setDisplayCustomerUpload] = useState(false);
  const [selectedBrandId, setSelectedBrandId] = useState("");
  const [brandStoreList, setBrandStoreList] = useState([]);
  const [fileName, setFileName] = useState("");
  const [mapWithStore, setMapWithStore] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchBrandCustomer = (page) => {
    setLoading(true);
    const data = {
      sortOrder: "asc",
      sortBy: "id",
      limit: 15,
      offset: page * 15,
    };
    getBrandCustomer(brandId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setBrandCustomerData((prevData) => [...prevData, ...Res]);
          setLoading(false);
          setIsEndReached(Res.length < 15); // Set to true if fewer items are returned
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchBrandCustomer(page);
  }, [page]);

  const filterBrandCustomerList = () => {
    return brandCustomerData.filter((item) => {
      const customerMobile = item.mobile?.toLowerCase();
      const customerFirstName =
        item.firstName?.toLowerCase() + " " + item.lastName?.toLowerCase();
      const email = item.email?.toLowerCase();
      const address = item.address?.toLowerCase();
      const matchesSearchTermCustomerMobile = customerMobile?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermCustomerFirstName = customerFirstName?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermEmail = email?.includes(searchTerm.toLowerCase());
      const matchesSearchTermAddress = address?.includes(
        searchTerm.toLowerCase()
      );
      return (
        matchesSearchTermCustomerMobile ||
        matchesSearchTermCustomerFirstName ||
        matchesSearchTermEmail ||
        matchesSearchTermAddress
      );
    });
  };

  const filteredBrandCustomerData = filterBrandCustomerList();

  const onClickCustomerUpload = () => {
    setDisplayCustomerUpload(true);
    setSelectedBrandId(brandId);
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const getBrandStore = Res.map((item, index) => ({
            name: item.storeName,
            value: item.id,
          }));
          setBrandStoreList(getBrandStore);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const onHideCustomerUpload = () => {
    setFileName("");
    setSelectedImage(null);
    setDisplayCustomerUpload(false);
  };

   const handleCustomerDownload = () => {
     const link = document.createElement("a");
     link.href = "/bulk_upload_brand_customer.xlsx"; // File path inside public folder
     link.download = "bulk_upload_brand_customer.xlsx"; // Rename file on download
     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
   };

   const handleFileChange = (event) => {
     event.preventDefault();
     const file = event.target.files[0];
     setFileName(file ? file.name : ""); // Update the file name or clear it if no file is selected

     const reader = new FileReader();
     reader.onloadend = () => {
       setSelectedImage(reader.result);
     };
     if (file) {
       reader.readAsDataURL(file);
     } else {
       setSelectedImage(null);
     }
   };


    const renderDialogCustomerUpload = () => (
      <Dialog
        header="Customer Upload"
        visible={displayCustomerUpload}
        onHide={() => onHideCustomerUpload()}
        breakpoints={{ "960px": "75vw" }}
        style={{ width: "50vw" }}
      >
        <div>
          <form onSubmit={handleCustomerUpload}>
            <div className="row mb-3">
              <div
                className="col-md-12"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <button
                  onClick={handleCustomerDownload}
                  style={{
                    padding: "10px",
                    background: "blue",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Download Sample File
                </button>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-12">
                <label htmlFor="qrCodeCount" className="form-label">
                  Store Selection
                </label>
              </div>
              <Dropdown
                value={mapWithStore}
                options={brandStoreList}
                optionLabel="name"
                onChange={(e) => {
                  setMapWithStore(e.target.value);
                }}
                placeholder="Select a Store"
              />
            </div>
            <div className="row mb-3">
              <div
                className="col-md-12"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <label for="file-upload" className="custom-file-upload">
                    <i className="pi pi-upload"></i> Choose Customer File
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </div>
                <div>
                  <i
                    className="pi pi-file"
                    style={{ color: "blue", fontSize: "40px" }}
                  ></i>
                  {fileName && (
                    <p
                      style={{
                        alignSelf: "center",
                        fontSize: 14,
                        fontWeight: 600,
                        margin: 10,
                      }}
                    >
                      {fileName}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="row mb-3">
            <p className="text-lg " style={{color:'red'}}>
              Only required format data will be considered
            </p>
            </div>
            {selectedImage && (
              <div className="col-md-12 text-center">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            )}
          </form>
        </div>
      </Dialog>
    );

    const handleCustomerUpload = (event) => {
      event.preventDefault();
      const fileInput = event.target.querySelector('input[type="file"]');
      const uploadFile = fileInput.files[0];

      if (!uploadFile) {
        console.error("No file selected");
        return;
      }

      brandCustomerUpload(selectedBrandId, uploadFile, mapWithStore)
        .then((response) => {
          const Res = response.data;
          // handle the response
          if (Res.status === true) { 
            successMessage("Customer Upload Successfully " + Res.message);
            setMapWithStore("");
            setSelectedBrandId("");
              setFileName("");
              setSelectedImage(null);
            setDisplayCustomerUpload(false);
          } else {
            errorMessage("Customer Upload Failed " + Res.message);
            setMapWithStore("");
            setSelectedBrandId("");
              setFileName("");
              setSelectedImage(null);
            setDisplayCustomerUpload(false);
          }
        })
        .catch((error) => {
          // handle errors
          errorMessage("Customer Upload Failed");
          setMapWithStore("");
          setSelectedBrandId("");
          setDisplayCustomerUpload(false);
        });
    };


  // const getData = () => {
  //   if (!isEndReached && !loading) {
  //     setPage((prevPage) => prevPage + 1);
  //     ds.current.load();
  //   }
  // };

  // const handleClearSearch = () => {
  //   setSearchTerm("");
  //   setLoadingSearch(true);
  //   setPage(0);
  // };

  // const itemTemplate = (data) => {
  //   const firstName = data.firstName ? data.firstName : "";
  //   const lastName = data.lastName ? data.lastName : "";
  //   const fullName = firstName + " " + lastName;
  //   const fullAddress =
  //     data.addressDTO !== null
  //       ? data.addressDTO.fullAddress
  //         ? data.addressDTO.fullAddress
  //         : ""
  //       : "";
  //   return (
  //     <div className="flex-1 ">
  //       <div className="m-4 shadow-4">
  //         <div className="flex flex-1">
  //           <div
  //             className="flex-1 px-3 py-1"
  //             style={{
  //               backgroundColor: "#F8FFEE",
  //             }}
  //           >
  //             <p
  //               className="text-md font-normal capitalize"
  //               style={{ color: "#75879B" }}
  //             >
  //               Name :
  //             </p>
  //             <p className="text-lg font-medium capitalize"> {fullName}</p>
  //           </div>
  //           <div
  //             className="flex-1 px-3 py-1"
  //             style={{
  //               backgroundColor: "#E2F4F8",
  //             }}
  //           >
  //             <p
  //               className="text-md font-normal capitalize"
  //               style={{ color: "#75879B" }}
  //             >
  //               Mobile No. :
  //             </p>
  //             <p className="text-lg font-medium capitalize">{data.mobile}</p>
  //           </div>
  //         </div>
  //         <div className="flex flex-1">
  //           <div
  //             className="flex-1 px-3 py-1"
  //             style={{
  //               backgroundColor: "#E2F4F8",
  //             }}
  //           >
  //             <p
  //               className="text-md font-normal capitalize"
  //               style={{ color: "#75879B" }}
  //             >
  //               Email :
  //             </p>
  //             <p className="text-lg font-medium capitalize">{data.email}</p>
  //           </div>
  //           <div
  //             className="flex-1 px-3 py-1"
  //             style={{
  //               backgroundColor: "#F8FFEE",
  //             }}
  //           >
  //             <p
  //               className="text-md font-normal capitalize"
  //               style={{ color: "#75879B" }}
  //             >
  //               Address :
  //             </p>
  //             <p className="text-lg font-medium capitalize">{fullAddress}</p>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // const addressTemplate = (rowData) => {
  //   const fullAddress =
  //     rowData.addressDTO !== null
  //       ? rowData.addressDTO.fullAddress
  //         ? rowData.addressDTO.fullAddress
  //         : ""
  //       : "";
  //   return (
  //     <div
         
  //     >
  //       <p >
  //         {fullAddress}
  //       </p>
  //     </div>
  //   );
  // };

  // const nameTemplate = (rowData) => {
  //   const firstName = rowData.firstName ? rowData.firstName : "";
  //   const lastName = rowData.lastName ? rowData.lastName : "";
  //   const fullName = firstName + " " + lastName;
  //   return (
  //     <div
         
  //     >
  //       <p >
  //         {fullName}
  //       </p>
  //     </div>
  //   );
  // };

  // const RenderTabView = () => {
  //   return (
  //     <DataTable
  //       showGridlines
  //       value={filteredBrandCustomerData}
  //       // header={header}
  //       paginator
  //       rows={15}
  //       rowsPerPageOptions={[15, 50, 75, 100]}
      
  //       stripedRows
  //     >
  //     <Column
  //         field="Customer Name"
  //         header="Name"
           
  //         body={nameTemplate}
  //       ></Column>
  //       <Column
  //         field="Mobile"
  //         header="Mobile No."
           
  //         body={rowData => rowData?.mobile}
  //       ></Column>
  //        <Column
  //         field="Email"
  //         header="Email"
           
  //         body={rowData => rowData?.email}
  //       ></Column>
  //       <Column
  //         field="address"
  //         header="Address"
           
  //         body={addressTemplate}
  //       ></Column>
  //     </DataTable>
  //   );
  // };

  // const exportExcel = () => {
  //     import("xlsx").then((xlsx) => {
  //       // Map only the required fields for export
  //       const exportData = filteredBrandCustomerData.map((item) => ({
  //         "Name": (item.firstName ? item.firstName : "") + " " + (item.lastName ? item.lastName : ""),
  //         "Mobile No.": item.mobile,
  //         "Email": item.email,
  //         "Address": item.addressDTO !== null
  //             ? item.addressDTO.fullAddress
  //               ? item.addressDTO.fullAddress
  //               : ""
  //             : ""
  //       }));
    
  //       const worksheet = xlsx.utils.json_to_sheet(exportData);
  //       const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
  //       const excelBuffer = xlsx.write(workbook, {
  //         bookType: "xlsx",
  //         type: "array",
  //       });
    
  //       saveAsExcelFile(excelBuffer, "Customers");
  //     });
  //   };
    
  
    // const saveAsExcelFile = (buffer, fileName) => {
    //   import("file-saver").then((module) => {
    //     if (module && module.default) {
    //       let EXCEL_TYPE =
    //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    //       let EXCEL_EXTENSION = ".xlsx";
    //       const data = new Blob([buffer], {
    //         type: EXCEL_TYPE,
    //       });
  
    //       module.default.saveAs(
    //         data,
    //         fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    //       );
    //     }
    //   });
    // };

    const sentMail = async () => {
      brandAllCustomerData(brandId)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res.status === true) {
              setModalVisible(true);
              setModalStatus("success");
              setModalText(Res.message);
            } else {
              setModalVisible(true);
              setModalStatus("notSuccess");
              setModalText(Res.message);
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    };

  const backgroundImage = "/images/customer_mail.png";

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Customers
              </p>
            </div>
          </div>
          {/*<div className="flex justify-content-center align-items-center">
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                  onClick={exportExcel}
                  src={"images/file.png"}
                  style={{
                    width: 30,
                  }}
                />
              </div>
            </div>*/}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className=" flex-1">
        <div
          className="flex items-center justify-center"
          // style={{
          //   backgroundImage: `url(${backgroundImage})`,
          //   backgroundSize: "cover",
          //   backgroundPosition: "center",
          //   backgroundRepeat: "no-repeat",
          //   width: "50vw",
          //   height: "100vh",
          // }}
        >
          <div className="flex-1 ml-8 my-4">
            <p className="text-6xl font-bold " style={{ color: "purple" }}>
              Get Your
            </p>
            <p className="text-8xl font-bold " style={{ color: "#052452ff" }}>
              Customer Data
            </p>
            <p
              className="text-5xl font-bold my-2 ml-2"
              style={{ color: "purple" }}
            >
              In Your Registered Email
            </p>
            {notifyEmail.split(",").map((email, index) => (
              <p
                key={index}
                className="text-xl font-bold my-2 ml-2"
                style={{ color: "#052452ff" }}
              >
                {email.trim()}
              </p>
            ))}
            <div className="flex  my-6">
              <div className="flex  my-6">
                <div
                  className="golden-button-delivery-date cursor-pointer"
                  onClick={() => sentMail()}
                >
                  <p className="shine text-5xl font-bold " />
                  Sent Mail
                </div>
              </div>
              <div className="flex  my-6">
                <div
                  className="golden-button-delivery-date cursor-pointer"
                  onClick={() =>
                    onClickCustomerUpload("displayCustomerUpload")
                  }
                >
                  <p className="shine text-5xl font-bold " />
                  Upload More Customer
                </div>
              </div>
            </div>
          </div>
          <div
            className="flex-1"
            style={{
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              height: "92vh",
            }}
          >
            {/*<img
              style={{ width: "125px" }}
              src="/images/customer_mail.png"
              alt="logo"
            />*/}
          </div>
        </div>
      </div>

      {/* <div className="  my-4">
        <div className="my-2 mx-5 flex flex-1">
          <div className="flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={"Search Customer"}
                value={searchTerm}
                keyboardType={"default"}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>

          {searchTerm && (
            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={handleClearSearch}
            >
              <div>
                <p className="text-4xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            </div>
          )}
        </div>

        {loadingSearch || loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : filteredBrandCustomerData?.length > 0 ? (
          <div>
            <div
              className="scroll-bar mb-2"
              style={{
                height: height > 600 ? 520 : 360,
                overflowY: "scroll",
              }}
            >
              <div className="mx-4 report-table">
                <div className="tab-view-table">{RenderTabView()}</div>
              </div>
            </div>

            <div style={{ display: "none" }}>
              <DataScroller
                value={filteredBrandCustomerData}
                itemTemplate={itemTemplate}
                rows={filteredBrandCustomerData?.length + 100}
                inline
                ref={ds}
                scrollHeight={height > 600 ? "520px" : "460px"}
                loader
                // footer={footer}
              />
            </div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Order Found</p>
          </div>
        )}

        <div
          className="flex justify-content-center fixed "
          style={{ bottom: 80, right: 20 }}
        >
          <Button
            type="text"
            icon="pi pi-plus"
            // label="More"
            onClick={getData} // Update this to trigger `getData`
          />
        </div>
      </div>*/}
      <AdminMenu setVisible={setVisible} visible={visible} />
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
      <div>{renderDialogCustomerUpload()}</div>
    </div>
  );
};

export default BrandCustomerList;
